import { render } from "./VField.vue?vue&type=template&id=4d72e180&scoped=true"
import script from "./VField.vue?vue&type=script&lang=js"
export * from "./VField.vue?vue&type=script&lang=js"

import "./VField.vue?vue&type=style&index=0&id=4d72e180&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d72e180"]])

export default __exports__